import { Button, Col, Input, Row, Space, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import {
  displayFormattedDate,
  formatCurrency,
  isEmpty,
} from "../../../generalFunctions";
import useApi from "../../../hooks/useApi";
import EmailModal from "../../common/EmailModal";
import PrintPdfModal from "../../common/PrintPdfModal";
import TableComponent from "../../common/table/TableComponent";
import DeleteModal from "../../common/DeleteModal";
import {
  EditOutlined,
  EyeOutlined,
  DeleteOutlined,
  PrinterOutlined,
} from "@ant-design/icons";

function ReceiptTable() {
  const [visiblePrint, setVisiblePrint] = useState(false);
  const [visibleEmail, setVisibleEmail] = useState(false);
  const columns = [
    {
      title: "Receipt Number",
      dataIndex: "id",
      width: "100px",
    },
    {
      title: "Receipt Date",
      dataIndex: "receiptDate",
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Receipt For",
      dataIndex: "receiptFor",
    },
    {
      title: "Receipt Type",
      dataIndex: "receiptType",
    },
    {
      title: "Narration",
      dataIndex: "narration",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (text) => formatCurrency(text),
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => editRecord(record)}>
            <EditOutlined />
          </Button>
          <Button size="small" onClick={() => editRecord(record, true)}>
            <EyeOutlined />
          </Button>
          <Button size="small" onClick={() => handlePrint(record)}>
            <PrinterOutlined />
          </Button>
          <Button size="small" onClick={() => handleDelete(record)}>
            <DeleteOutlined />
          </Button>
          {/* <Button size="small" onClick={() => handleEmail(record)}>
            Email
          </Button> */}
        </Space>
      ),
    },
  ];

  const [responseData, getRequest] = useApi("/receipt", null, API_METHODS.GET);
  const [tableData, setTableData] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [visibleDelete, setVisibleDelete] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getRequest(null, API_METHODS.GET, `/receipt?pageNumber=${1}`);
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setTableData(data);
    setTotalRecords(data && data.length > 0 ? data[0].count : 0);
  }, [responseData]);

  const editRecord = (record, isViewOnly = false) => {
    if (isViewOnly) {
      navigate("/portal/receipt/view", {
        state: { receipt_id: record.id, isViewOnly: isViewOnly },
      });
    } else {
      navigate("/portal/receipt/edit", {
        state: { receipt_id: record.id, isViewOnly: isViewOnly },
      });
    }
  };

  const onRowSelectChange = (newSelectedRowKeys, records) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(records);
  };

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    onChange: onRowSelectChange,
  };

  const onReceiptSearch = (id) => {
    if (!isEmpty(id))
      navigate("/portal/receipt/view", {
        state: { receipt_id: id, isViewOnly: false },
      });
  };

  const handlePrint = (record) => {
    const flag = visiblePrint ? false : true;
    record && setSelectedRecord(record);
    setVisiblePrint(flag);
  };

  const handleEmail = (record) => {
    const flag = visibleEmail ? false : true;
    record && setSelectedRecord(record);
    setVisibleEmail(flag);
  };

  const onPaginationChange = (page) => {
    getRequest(null, API_METHODS.GET, `/receipt?pageNumber=${page.current}`);
    setCurrentPage(page.current);
  };

  const handleDelete = (record) => {
    const flag = visibleDelete ? false : true;
    record && setSelectedRecord(record);
    setVisibleDelete(flag);
  };

  return (
    <>
      <Row>
        <Col span={6}>
          <Typography.Title level={5}>Receipt</Typography.Title>
        </Col>
        <Col span={18}>
          <Space style={{ marginBottom: 10, float: "right" }}>
            <Input.Search
              placeholder="Receipt Number"
              allowClear
              enterButton="Search"
              onSearch={onReceiptSearch}
            />
            <Button>
              <Link to="add">Add Receipt</Link>
            </Button>
            <Button
              type="primary"
              onClick={handlePrint}
              disabled={selectedRows.length === 0}
            >
              Print Selected Receipts
            </Button>
          </Space>
        </Col>
      </Row>
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        rowSelection={rowSelection}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />

      {visiblePrint && (
        <PrintPdfModal
          visible={visiblePrint}
          data={selectedRows.length !== 0 ? selectedRows : [selectedRecord]}
          title={"Receipt"}
          close={handlePrint}
          pdfType="receipt"
        />
      )}

      {visibleEmail && (
        <EmailModal
          attachmentType="Reciept"
          visible={visibleEmail}
          accountId={selectedRecord?.receiptForId}
          record={selectedRecord}
          close={handleEmail}
        />
      )}

      {visibleDelete && (
        <DeleteModal
          visible={visibleDelete}
          close={handleDelete}
          recordType="Receipt"
          record={selectedRecord}
          refresh={() => {
            getRequest(null, API_METHODS.GET, `/receipt?pageNumber=${1}`);
          }}
        />
      )}
    </>
  );
}

export default ReceiptTable;
